"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProgressStyled = require("./Progress-styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Progress = function Progress(_ref) {
  var _ref$reversed = _ref.reversed,
      reversed = _ref$reversed === void 0 ? false : _ref$reversed,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? null : _ref$text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'determinate' : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      other = _objectWithoutProperties(_ref, ["reversed", "text", "type", "value"]);

  return _react.default.createElement(_ProgressStyled.StyledProgress, other, _react.default.createElement(_ProgressStyled.Track, null, _react.default.createElement(_ProgressStyled.Bar, {
    reversed: reversed,
    type: type,
    value: value
  })), text && _react.default.createElement(_ProgressStyled.Text, null, text));
};

Progress.propTypes = {
  /** For indeterminate progress bars, reverse the animation direction */
  reversed: _propTypes.default.bool,

  /** Text label for the progress indicator	 */
  text: _propTypes.default.string,

  /** Use indeterminate if finding actual progress value is impossible */
  type: _propTypes.default.oneOf(['determinate', 'indeterminate']),

  /** Fraction completed, in the range of 0 - 1.0 */
  value: _propTypes.default.number
};
var _default = Progress;
exports.default = _default;